import useApiHelpers from "./helpers";

const { getRequest } = useApiHelpers();

export default function useSettingsEndpoints() {
  const getRestrictedUSStatesSettings = async () => {
    const response = await getRequest(`/settings/states/US`);
    return response;
  };
  return {
    getRestrictedUSStatesSettings,
  };
}
